// extracted by mini-css-extract-plugin
export default {"add":"Home_add__IhORM","wrapper":"Home_wrapper__iZIsl","seeAll":"Home_seeAll__V5ZSf","header":"Home_header__jgN9+","main":"Home_main__3ilkD"};